import { getUserAuthValues } from '@/utils/general/user'

// Phone isn't in the auth cookie, so we stash it in the modal (where we have it)
// and read it back after the post-login reload, once the cookie is reliably set.
const PHONE_KEY = 'CT_LOGIN_MOBILE'
const CC_KEY = 'CT_LOGIN_CC'

// Called from the login modal (before reload) to persist phone across the reload.
export const stashLoginPhone = (countryCode: string, mobile: string) => {
    try {
        window?.localStorage?.setItem(CC_KEY, countryCode || '')
        window?.localStorage?.setItem(PHONE_KEY, mobile || '')
    } catch (e) {
        // no-op
    }
}

// Called from _app.tsx on mount (after reload); cookie is set by now, phone from storage.
export const flushClevertapLoginProfile = () => {
    try {
        const mobile = window?.localStorage?.getItem(PHONE_KEY)
        if (!mobile) return
        const countryCode = window?.localStorage?.getItem(CC_KEY) || ''
        const { userId, email, gender } = getUserAuthValues()
        clevertapProfileHelper({ id: userId, gender, username: email, countryCode, mobile })
        window.localStorage.removeItem(PHONE_KEY)
        window.localStorage.removeItem(CC_KEY)
    } catch (e) {
        // no-op
    }
}

const clevertapProfileHelper = (profileDetails: { id?: string, gender?: string, username: string, countryCode?: string, mobile: string }) => {
    try {
        const Site: Record<string, unknown> = {
            Identity: profileDetails?.id ?? '',
            Gender: profileDetails?.gender ?? 'unknown',
            Email: profileDetails?.username ?? '',
            Phone: `${profileDetails?.countryCode}${profileDetails?.mobile}`,
            'MSG-sms': true,
            'MSG-push': true,
            'MSG-email': false,
            'MSG-whatsapp': true,
        };
        window?.clevertap?.onUserLogin.push({ Site });
    }
    catch (e) {
        console.log(e, "clevertap user details push failed")
    }
}


export default clevertapProfileHelper